import React, { Component } from 'react'
import { navigateTo } from "gatsby-link"
import { Menu, Container } from 'semantic-ui-react'

import { store } from '../../store';

import styles from "./nav.module.css"

export default class Nav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeItem: '',
    }

    this.handleItemClick = this.handleItemClick.bind(this);
  }

  handleItemClick(e, { name, to }) {
    this.setState({ activeItem: name });
    navigateTo(to);
  }

  componentDidMount() {
    const path = window.location.pathname.split('/');
    let item = '';

    // if root (/), set state to home. else set it to the path name.
    if(path.length === 2) {
      item = 'home';
    } else {
      item = path[1] || ''
    }
    
    this.setState({
      activeItem: item,
    });
  }

  render() {
    const { activeItem } = this.state

    return (
      <div>
          <Menu pointing secondary className={styles.menu}>
            <Container>
              <Menu.Item 
                name='home'
                to='/'
                active={activeItem === 'home'} 
                onClick={this.handleItemClick} 
              />
              <Menu.Item 
                name='public'
                to='/public/'
                active={activeItem === 'public'} 
                onClick={this.handleItemClick} 
              />
              <Menu.Item 
                name='user'
                to='/user/'
                active={activeItem === 'user'} 
                onClick={this.handleItemClick} 
              />
              <Menu.Item 
                name='admin'
                to='/admin/'
                active={activeItem === 'admin'} 
                onClick={this.handleItemClick} 
              />
              <Menu.Menu position='right'>
                  { true ?
                      <Menu.Item 
                        name='login' 
                        active={activeItem === 'login'} 
                        onClick={this.handleItemClick} 
                      /> :
                      <Menu.Item 
                        name='logout' 
                        active={activeItem === 'logout'} 
                        onClick={this.handleItemClick} 
                      />
                  }
              </Menu.Menu>
            </Container>
          </Menu>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/nav/index.js